<template>
    <div class="message-box dialog-mask" data-cy="confirm-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t(title, i18nData) }}</h4>
                </div>
                <div class="modal-body">
                    <!-- TODO: v-html can lead to XSS attacks and should be avoided  -->
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p v-html="$t(content, i18nData)"></p>
                </div>
                <div class="modal-footer">
                    <ModalMultiButtons
                        :loading="loading"
                        data-cy="buttons"
                        btn-primary-id="confirm"
                        :btn-primary-text="$t(confirmLabel)"
                        :btn-secondary-text="$t(cancelLabel)"
                        :primary-button-click="clickYes"
                        :secondary-button-click="clickNo"
                        :secondary-button-hide="!cancelLabel"
                    ></ModalMultiButtons>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ModalMultiButtons } from '@arena/toolkit';

export default {
    components: {
        ModalMultiButtons,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        confirmLabel: {
            type: String,
            default: 'Ok',
        },
        confirmResult: {
            type: Boolean,
            default: true,
        },
        confirmFunction: {
            type: Function,
            default: null,
        },
        cancelLabel: {
            type: String,
            default: '',
        },
        cancelResult: {
            type: Boolean,
            default: false,
        },
        i18nData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        async clickYes() {
            try {
                if (this.confirmFunction) {
                    this.loading = true;
                    this.confirmResult = await this.confirmFunction();
                }
                this.$close(this.confirmResult);
            } catch (error) {
                this.$error(error);
            }
        },
        clickNo() {
            this.$close(this.cancelResult);
        },
    },
};
</script>
